import type { Styles } from "@/types/util"
import colors from "../utils/colors"

const backgroundColors: Record<string, string> = {
  green: colors.brandLightGreen,
  lightBlue: colors.brandLightBlue,
  lightRed: colors.statesErrorTertiary,
}

type Props = {
  splitAt?: string
  topColor: string
}

const SplitBackground = ({ splitAt = "210px", topColor }: Props) => {
  const styles = {
    splitBackground: {
      width: "100%",
      position: "absolute",
      top: 0,
      left: 0,
      zIndex: -500,
      height: splitAt,
      backgroundColor: backgroundColors[topColor] || topColor,
    },
  } satisfies Styles

  return <div style={styles.splitBackground} />
}

export default SplitBackground
